import BaseService from './baseService';

class RolePermission extends BaseService {
  	async getRoles(opts = {}) {
      this.endPoint = '/roles'
      return this.get(opts);
    }
    async getPermissions(opts={}){
      this.endPoint = '/roles/permission';
      return this.get(opts);
    }
    async addPermissions(payload){
      this.endPoint = '/roles/permission';

      return await this.post(payload)
    }
    async deletePermissions(id,opts={}){
      this.endPoint = '/roles/permission';

      return await this.delete(id,opts);
    }
    async setPermissionToRole(id,payload,opts={}){
      this.endPoint = '/roles/permission';
      return await this.putOne(id,payload,opts); 
    }
}

export default new RolePermission();